/**
 * Constantes para el módulo de planes
 */

// Configuración de paginación
export const ITEMS_PER_PAGE = 5;

// Estado inicial de un plan
export const INITIAL_PLAN_STATE = {
  name: '',
  effective_start_date: '',
  branch: null,
  installments_number: null,
  contracts_number: null,
  interest_rate: null,
  first_installment_amount: null,
  id: null,
  uuid_user: '',
  uuid_branch: '',
};

// Configuración de tabs para el diálogo de edición
export const DIALOG_TABS = {
  GENERAL_CONFIG: 0,
  GROUPS: 1,
  ADDITIONALS: 2,
  SCORE_COEFFICIENTS: 3,
  PRE_ADJ_REASONS: 4,
  CONSTRUCTION_TYPES: 5,
  PEI_VALUES: 6,
  FEE_TYPES: 7,
  FEE_STRUCTURES: 8,
  PAYMENT_METHODS: 9,
  PAYMENT_METHOD_DETAILS: 10,
};

// Labels para tabs
export const TAB_LABELS = {
  [DIALOG_TABS.GENERAL_CONFIG]: 'CONFIGURACIÓN DEL PLAN',
  [DIALOG_TABS.GROUPS]: 'GRUPOS',
  [DIALOG_TABS.ADDITIONALS]: 'ADICIONALES',
  [DIALOG_TABS.SCORE_COEFFICIENTS]: 'COEFICIENTES DE PUNTAJE',
  [DIALOG_TABS.PRE_ADJ_REASONS]: 'MOTIVOS DE PREADJUDICACIÓN',
  [DIALOG_TABS.CONSTRUCTION_TYPES]: 'TIPOS DE CONSTRUCCIÓN',
  [DIALOG_TABS.PEI_VALUES]: 'VALORES PEI',
  [DIALOG_TABS.FEE_TYPES]: 'TIPOS DE CUOTAS',
  [DIALOG_TABS.FEE_STRUCTURES]: 'ESTRUCTURA DE CUOTAS',
  [DIALOG_TABS.PAYMENT_METHODS]: 'FORMAS DE PAGO',
  [DIALOG_TABS.PAYMENT_METHOD_DETAILS]: 'DETALLE DE FORMAS DE PAGO',
};

// Estados de validación
export const VALIDATION_RULES = {
  REQUIRED_FIELDS: [
    'name',
    'effective_start_date',
    'installments_number',
    'contracts_number',
    'interest_rate',
    'first_installment_amount',
  ],
  MIN_VALUES: {
    installments_number: 1,
    contracts_number: 1,
    interest_rate: 0,
    first_installment_amount: 0,
  },
};

// Mensajes
export const MESSAGES = {
  PLAN_CREATED: 'Plan creado correctamente',
  PLAN_UPDATED: 'Plan actualizado correctamente',
  PLAN_DELETED: 'Plan eliminado correctamente',
  ERROR_CREATING: 'Error al crear el plan',
  ERROR_UPDATING: 'Error al actualizar el plan',
  ERROR_DELETING: 'Error al eliminar el plan',
  CONFIRM_DELETE: '¿Confirma que desea eliminar este plan?',
};
